<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="pageTitleLabel"
    />

    <v-progress-circular
      v-if="loadingScenarioPreferences"
      size="130"
      width="15"
      class="d-block mx-auto"
      indeterminate
      color="primary"
    />
    <v-container v-else class="px-12 pt-7 pb-1 mt-2" fluid>
      <scenario-block
        v-if="!(validatedOptionMode && selectedOptionMode === 4) && (!!availableScenarii.length  || !!currentScenario.id) && !enableunion"
        @changeScenario="changeScenario($event)"
        :scenario="currentScenario"
        :scenarios="availableScenarii"
        :disableDropDownList="disableDropDownList"
        v-on="$listeners"
      />
      <span v-else-if="validatedOptionMode && selectedOptionMode === 4">
        
      </span>
      <span v-else-if="!availableScenarii.length && !optionBlockList.length && !loadingScenarioPreferences && !enableunion">
        {{ $t('conflict.noResolutionToDo') }}
      </span>

      <option-block
        v-if="(!validatedOptionMode || (selectedOptionMode > 0 && selectedOptionMode !== 4)) && availableScenarii.length && !enableunion"
        :list-label="optionBlockLabel"
        :options="optionBlockList"
        :loading="loadingScenarioPreferences || !currentScenario.id"
        :draggable="validatedOptionMode && selectedOptionMode === 3 && !disallowDrag"
        :asGroup="asGroup"
        v-on="$listeners"
      />

      <!-- 4 yes/no blocks -->
      <favorite-option
        v-if="!validatedOptionMode && availableScenarii.length && !enableunion || (validatedOptionMode && selectedOptionMode === 6)"
        @selectOptionMode="selectOptionMode($event)"
        :selected-option-mode="selectedOptionMode"
        :hide-no-i-prefer-making-groups="hideCase43NoIPreferMakingGroups"
        :hide-no-i-can-not-decide="lock"
      />
      <v-row justify="center" v-if="selectedOptionMode && !validatedOptionMode && !enableunion || (validatedOptionMode && selectedOptionMode === 6)">

        <raison-button
          :button-label="$t('global.validate')"
          :button-function="askConfirmation"
        >
          <template v-slot:append>
            <v-icon right>mdi-arrow-right</v-icon>
          </template>
        </raison-button>
      </v-row>

      <option-1-workflow
        v-if="validatedOptionMode && selectedOptionMode === 1 && !enableunion"
        ref="option1Workflow"
        :preference-list="preferenceList"
        :current-scenario="currentScenario"
        @preferedOption="setPreferedOption($event)"
        @updateCurrentScenario="updateCurrentScenario"
        @updateCurrentPreference="updateCurrentPreference"
        @addTodo="addTodo($event)"
        @addPreferenceToList="addPreferenceToList"
        @nextTodo="nextTodo"
        :input-validated-selected-option="shortcutToOption4"
        v-on="$listeners"
        :beliefMode="beliefMode"
        :preferred-options="preferedOption"
      />

      <option-2-workflow
        ref="option2Workflow"
        v-if="validatedOptionMode && selectedOptionMode === 2 && !enableunion"
        @preferedOption="setPreferedOption($event)"
        @addPreferenceToList="addPreferenceToList"
        @groupCreated="currentGroupId = $event"
        @addTodo="addTodo($event)"
        @nextTodo="nextTodo"
        :available-options="availableGroups"
        :current-scenario="currentScenario"
        :preference-list="preferenceList"
        :scenario-of-level2-or-more="contextualPreferences.map(pref => pref.scenario)"
        :chosenOption="wigos"
        v-on="$listeners"
        @updateScenario="updateScenario"
        :beliefMode="beliefMode"
      />

      <option-3-workflow
        v-if="validatedOptionMode && selectedOptionMode === 3 && !enableunion"
        :preference-list="preferenceList"
        @preferedOption="setPreferedOption($event)"
        @possibleOptions="setPreferedOption($event, true)"
        @addPreferenceToList="addPreferenceToList"
        @restoreOption="preferedOption.push($event)"
        @addTodo="addTodo($event)"
        @nextTodo="nextTodo"
        @groupSelected="currentGroupId = null"
        :available-options="availableOptions"
        :current-scenario="currentScenario"
        v-on="$listeners"
      />

      <option-4-workflow
        v-if="validatedOptionMode && selectedOptionMode === 4 && !enableunion"
        @preferedOption="setPreferedOption($event)"
        @newScenario="updateCurrentScenario($event)"
        @validateInformations="validateInformations($event)"
        @nextTodo="nextTodo"
        @addTodo="addTodo($event)"
        @updateCurrentPreference="updateCurrentPreference"
        @addPreferenceToList="addPreferenceToList"
        :reload-preferences-list="loadPreferences"
        :available-options="availableOptions"
        :preference-list="preferenceList"
        :workingPreferences="workingPreferencesWf4"
        v-on="$listeners"
        :enable-finish-button="createdPreferencesForCase6.length > 0"
        :force-add.sync="forceAddForCase6"
        @piPrefAndPjPrefSelected="piPrefAndPjPrefSelected($event)"
        @refreshPreferences="processPreferences($event)"
        :beliefMode="beliefMode"
      />

      <created-preferences
        v-if="validatedOptionMode && selectedOptionMode !== 2  && selectedOptionMode !== 4 && !enableunion"
        :preferences="contextualPreferences"
        :current-elements="currentScenario.elements ? currentScenario.elements.map(elt => elt.id) : []"
        v-on="$listeners"
      />

      <created-preferences
        v-if="validatedOptionMode && selectedOptionMode === 2 && !enableunion"
        :preferences="createdPreferencesForCase2"
        :current-elements="currentScenario.elements ? currentScenario.elements.map(elt => elt.id) : []"
        v-on="$listeners"
      />

      <created-preferences
        v-if="validatedOptionMode && selectedOptionMode === 4 && !enableunion && !!(piPref.scenario && pjPref.scenario)"
        :preferences="createdPreferencesForCase6"
        :current-elements="[...piPref.scenario.elements, ...pjPref.scenario.elements].map(elt => elt.id)"
        :beliefMode="beliefMode"
        v-on="$listeners"
      />

      <conflict-scenario-multiple
        v-if="enableunion"
        :mergedscenario="mergedscenario"
        :piPref="piPref"
        :pjPref="pjPref"
        @nextTodo="nextTodo"
        @addTodo="addTodo($event)"
        v-on="$listeners"
        />
    </v-container>

    <warn-clear-resolution-dialog
      :loading="isClearingResolutions"
      :open="warnClearDialog"
      @confirm="startResolution({forceClearResolution: true})"
      @cancel="warnClearDialog = false"
    />

    <footer-navigation
      :prev-button-function="navigationPreviousFunction"
      :prev-button-label="navigationPreviousLabel"
      :next-button-function="navigationNextFunction"
      :next-button-label="navigationNextLabel"
    />
    
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import RaisonButton from '@/components/global/RaisonButton';
import ScenarioBlock from '@/components/global/ScenarioBlock';
import OptionBlock from '@/components/global/OptionBlock';
import FavoriteOption from '@/components/conflictResolution/FavoriteOption';
import Option1Workflow from '@/components/conflictResolution/Option1Workflow';
import Option2Workflow from '@/components/conflictResolution/Option2Workflow';
import Option3Workflow from '@/components/conflictResolution/Option3Workflow';
import Option4Workflow from '@/components/conflictResolution/Option4Workflow';
import CreatedPreferences from '@/components/conflictResolution/CreatedPreferences';
import FooterNavigation from '@/components/layout/FooterNavigation';
import ConflictScenarioMultiple from '@/components/conflictResolution/ConflictScenarioMultiple';
import WarnClearResolutionDialog from '@/components/conflictResolution/WarnClearResolutionDialog';

import _ from 'lodash';

import projectPageMixin from '@/mixins/project-page-mixin.js';

import scenarioService from '@/services/scenarios.js';
import optionService from '@/services/options.js';
import believeService from '@/services/believes.js';
import contextService from '@/services/contexts.js';
import list from '@/utils/list.js';


function sameId (o1, o2) {
  return  o1.id === o2.id;
}

export default {
  name: 'ConflictResolution',

  components: {
    PageContentToolbar,
    RaisonButton,
    ScenarioBlock,
    OptionBlock,
    FavoriteOption,
    Option1Workflow,
    Option2Workflow,
    Option3Workflow,
    Option4Workflow,
    CreatedPreferences,
    FooterNavigation,
    ConflictScenarioMultiple,
    WarnClearResolutionDialog,
  },

  mixins: [ projectPageMixin ],

  props: {
    shortcutToOption4: {
      type: Boolean,
      required: false,
      default: false,
    },
    beliefMode: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data () {
    return {
      projectId: '',
      warnClearDialog: false,
      currentScenario: {},
      currentPreference: {},
      scenarioList: [],
      optionList: [],
      preferenceList: [],
      selectedOptionMode: this.shortcutToOption4 ? 4 : 0,
      validatedOptionMode: this.shortcutToOption4, // indicates if we are choosing the case of resolution
      preferedOption: undefined,
      possibleOptions: false,
      disallowDrag: false,
      loadingScenarioPreferences: false,
      todo: [],
      isClearingResolutions: false,
      navigationPreviousFunction: !this.shortcutToOption4 ? this.backToScenariiList : (this.beliefMode ? this.goToMinimalScenariosForBeliefs : this.goToResolveConflictWithMinimalScenarios),
      navigationPreviousLabel: !this.shortcutToOption4 ? 'project.knowledgeRepresentation' : (this.beliefMode ? `scenario.argueBelief` : 'project.resolveConflictsWithinMinimumScenarios'),
      navigationNextFunction: !this.shortcutToOption4 ? this.goToResolveConflictInCombinationsOfMinimumScenarios : undefined,
      navigationNextLabel: !this.shortcutToOption4 ? 'project.resolveConflictsInCombinationsOfMinimumScenarios' : undefined,
      enableunion: false,
      mergedscenario: {},
      piPref : {},
      pjPref : {},
      comFrom : undefined,
      wigos : [],
      loading: false,
      availableGroups: [],
      workingPreferencesWf4: {
        pref1: null,
        pref2: null,
      },
      forceAddForCase6: false,
      currentGroupId: null,
    };
  },

  computed: {
    lock() {
      return this.currentPreference.previousPreferences?.length > 0
    },

    hideCase43NoIPreferMakingGroups() {
      return this.optionBlockList.length < 3;
    },

    asGroup() {
      return !!this.currentPreference.groupId || !!this.currentGroupId;
    },

    pageTitleLabel() {
      let label = 'project.resolveConflictsWithinMinimumScenarios';
      if(this.beliefMode) {
        label = 'project.resolveConflictsWithinMinimumScenariosForBeliefs';
      }
      if(this.selectedOptionMode === 4) {
        label = 'project.resolveConflictsInCombinationsOfMinimumScenarios';
        if(this.beliefMode) {
          label = 'project.resolveConflictsInCombinationsOfMinimumScenariosForBeliefs';
        }
      }
      return this.$t(label);
    },

    wigoProperty() {
      return believeService.wigoProperty(this.beliefMode);
    },

    logoProperty() {
      return believeService.logoProperty(this.beliefMode);
    },

    disableDropDownList() {
      return (this.validatedOptionMode && this.selectedOptionMode > 0) || this.lock;
    },

    optionBlockLabel () {
      if (this.preferedOption && (this.selectedOptionMode === 1 || this.selectedOptionMode === 2 || (this.selectedOptionMode === 3 && !this.possibleOptions) || this.selectedOptionMode === 4)) {
        if(Array.isArray(this.preferedOption)) {
          if(this.preferedOption.length === 0) {
            if(this.asGroup) {
              return this.$t('option.possibleGroup');
            }
            return this.$t('option.possible');
          }
          if(this.asGroup) {
            return this.$t('option.favoriteGroup')
          }
          if(this.preferedOption.length > 1) {
            return this.$t('option.favorites');
          }
          return this.$t('option.favorite');
        }
        return this.$t('option.favorite');
      }
      if(this.asGroup) {
        return this.$t('option.possibleGroup');
      }
      return this.$t('option.possible');
    },

    optionBlockList () {
      if(this.selectedOptionMode === 2 && this.availableGroups.length > 0) {
        console.log('optionBlockList availableGroups', this.availableGroups)
        return this.availableGroups;
      }
      if (this.preferedOption && (this.selectedOptionMode === 1 ||  this.selectedOptionMode === 2) ) {
        console.log('optionBlockList [ this.preferedOption ]', [ this.preferedOption ])
        return [ this.preferedOption ];
      }
      if (this.preferedOption) {
        console.log('optionBlockList this.preferedOption', this.preferedOption)
        return this.preferedOption;
      }
      console.log('optionBlockList availableOptions', this.availableOptions)
      return this.availableOptions;
    },

    // If size(Prefsi) > 1 then f_4.0_00(Si)
    availableScenarii () {
      const onlyMinimalScenarios = this.preferenceList
          .filter(pref => scenarioService.isMinimalPreference(pref, this.beliefMode))
          .map(pref => pref.scenario);

      return list.keepOnlyDuplicatesById(onlyMinimalScenarios);
    },

    availableOptions () {
      if (this.shortcutToOption4 && this.currentPreference[this.logoProperty]?.length > 0) {
        return this.currentPreference[this.logoProperty];
      }
      const currWigos = this.preferenceList.filter(pref => pref.scenario.id === this.currentScenario.id)
        .flatMap(pref => pref[this.wigoProperty]);

      if (currWigos.length) {
        return this.optionList.filter(opt => currWigos.some(wigo => wigo.id === opt.id));
      }
      return [];
    },

    contextualPreferences () {
      console.log("createdPreferencesForCase1 with "+ this.preferenceList.length + " preferences")
      return contextService.getContextCase1(this.preferenceList, this.beliefMode, this.currentPreference);
    },

    createdPreferencesForCase2 () {
      console.log("createdPreferencesForCase2 with "+ this.preferenceList.length + " preferences")
      return contextService.getContextCase2(this.preferenceList, this.currentScenario, this.currentGroupId);
    },

    createdPreferencesForCase6 () {
      return contextService.getContextCase6(this.preferenceList, this.piPref, this.pjPref);
    },

    isStartingConflictResolution() {
      return this.currentScenario.level === 1;
    }
  },

  methods: {
    log(msg) {
      console.log(msg); 
    },

    selectOptionMode (optionMode) {
      this.selectedOptionMode = optionMode;
    },

    shouldAskConfirmation() {
      const hasNext = this.preferenceList.some(pref => pref.scenario.previousLevel.includes(this.currentScenario.id));
      const resolved = this.currentScenario.extend === 'false';
      const hasTodos = this.todo.length > 0;
      return this.isStartingConflictResolution && hasNext && resolved && !hasTodos; // && this.selectedOptionMode !== 3;
    },

    askConfirmation() {
      if(this.shouldAskConfirmation()) {
        // display prevention message only on the start of the conflict resolution
        this.warnClearDialog = true;
      }
      else {
        this.startResolution();
      }
    },

    /* Determine if a previous resolution should be done
     * transparently.
     * This occurs each time the user starts a resolution and 
     * there are already some preferences.
     * Except for the case 4.3 in order to support different kind of
     * groups to resolve a scenario.
     */
    shouldClearResolution() {
      return this.isStartingConflictResolution && this.selectedOptionMode !== 3
        // /* This is a real minimal scenario
        //  * and not one from a group to discriminate
        //  */
        && this.currentScenario.previousLevel.length > 0;
    },

    startResolution ({ forceClearResolution=false } = {}) {
      this.loadingScenarioPreferences = true;
      if(this.todo.length <= 0) {
        this.addTodo({ todo: 'f_4_0_00' });
      }

      this.currentScenario.extend = true;
      if(this.selectedOptionMode === 2) {
        this.availableGroups.splice(0, this.availableGroups.length, ...this.availableOptions.map(opt => [opt]));
        this.loadingScenarioPreferences = false;
      }
      if(forceClearResolution || this.shouldClearResolution()) {
        this.isClearingResolutions = true;
        this.preferenceList.splice(0, this.preferenceList.length);
        this.loadingScenarioPreferences = true;
        scenarioService.clearResolution(this.projectId, this.currentScenario.id).then(() => {
          this.warnClearDialog = false; 
          this.validatedOptionMode = true;
          // TODO qvdk possible improvement by refactor clear resolution to return all preferences
          this.loadPreferences(false);
          this.iCanNotDecide();
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] });
        })
        .finally(() => {
          this.isClearingResolutions = false;
          this.loadingScenarioPreferences = false;
        });
      }
      else {
        this.warnClearDialog = false; 
        this.validatedOptionMode = true;
        this.loadingScenarioPreferences = false;
        this.iCanNotDecide();
      }

    },

    iCanNotDecide() {
      if (this.selectedOptionMode === 6) {
        this.loadingScenarioPreferences = true;
        this.addTodo({'scenario': Object.assign({}, this.currentScenario), 'todo': 'extends false'});
        this.nextTodo();
        this.loadingScenarioPreferences = false;
      }
    },

    /* folowing methods are called after catching events from various workflows */
    updateCurrentScenario (scenario) {
      this.currentScenario = scenario;
    },

    updateCurrentPreference (preference) {
      this.currentPreference = preference;
    },

    addPreferenceToList (preference) {
      this.preferenceList.push(preference);
    },

    setPreferedOption (option, isPossibleOption = false) {
      console.log('setPreferedOption', option.map(opt => opt.prolog).join(','));
      if (!isPossibleOption) {
        this.disallowDrag = true;
      }
      this.possibleOptions = isPossibleOption;
      this.preferedOption = option;
    },

    validateNewElements (elements) {
      this.currentScenario.elements.push(...elements);
    },

    addTodo (event) {
      console.log('Adding a todo, we will treat it later dont worry');    
      console.log(event);
      this.todo.push(event);
    },

    // this method should set various parameters so that we solve next conflict in right screen
    nextTodo () {
      console.log('we should treat next todo now !')

      if (this.todo.length === 0) {
        console.log('EN PRINCIPE ICI ON A FINI, REVENIR SUR LACCEUIL DE CONFLICT RESOLUTION ');
        return;
      }

      let nextTodo = this.todo.pop();
      console.log('nextTodo: ' + nextTodo.todo);
      if (nextTodo.todo === 'extends false') {
        this.setExtendFalse(nextTodo.scenario);
      } else if (nextTodo.todo === 'f_4.1_04(P)') {
        this.f_41_04(nextTodo.preference);
      } else if (nextTodo.todo === "f_4.2_02(S)") {
        this.f_42_02(nextTodo);
      } else if (nextTodo.todo === 'f_43_00') {
        this.f_43_00(nextTodo);
      } else if(nextTodo.todo === 'f_4_2_08') {
        this.f_4_2_08(nextTodo)
      } else if (nextTodo.todo === "f_6_01(Pi,Pj)") {
        this.f_6_01(nextTodo);
      } else if(nextTodo.todo === 'f_4_0_00') {
        this.f_4_0_00(nextTodo);
      } else if (nextTodo.todo === 'resolveCase6') {
        this.resolveCase6(nextTodo)
      }
    },
    /* end events methods */

    changeScenario (scenario) { // used only when user selects a scenario from top scenarioBlock
      this.reinit();
      this.currentScenario = scenario;
      this.currentPreference = this.preferenceList.find(pref => pref.scenario.id === this.currentScenario.id);
    },

    setExtendFalse (scenario) {
      scenarioService.markAsNoMoreExtendable(this.$route.params.id, scenario)
        .then(() => {
          this.nextTodo();
        })
        .catch((err) => {
          this.$emit("raison-event", { type: "error", messages: [ err ] });
        });
    },

    f_4_0_00 (todo) {
      this.reinit();
      this.loadPreferences(true, todo.scenarioId);
    },

    f_43_00(todo) {
      console.log('f_43_00', todo);
      this.reinit();
      this.currentScenario = todo.scenario;
      this.selectedOptionMode = 3;
      this.validatedOptionMode = true;
    },

    f_41_04 (preference) {
      this.selectedOptionMode = 1;
      console.log('F4104P ?', preference);
      this.currentPreference = preference;
      this.currentScenario = preference.scenario;
      this.preferedOption = preference[this.wigoProperty];

      this.$nextTick(() => {
        this.$refs.option1Workflow.currentPreference = preference;
        console.log('currentPreference', preference)
        this.$refs.option1Workflow.validatedSelectedOption = true;
        this.$refs.option1Workflow.proposedOption = preference[this.logoProperty];
        this.$refs.option1Workflow.canAddElementToPrefer = false;
        this.$refs.option1Workflow.selectedOption = preference[this.wigoProperty];
      });
    },

    f_42_02 (todo) {
      this.wigos = [];
      if(todo.from === 'case3') {
        console.log('f_42_02 from case3')
        this.comFrom = todo.from;
        this.currentGroupId = todo.currentGroupId;
        console.log('wigopreferedOptions ',this.wigos)
      }
      if(todo.preferedOption) {
        this.wigos.push(...todo?.preferedOptions);
      }
      if(todo.availableGroups) {
        this.availableGroups?.splice(0, this.availableGroups.length, ...todo.availableGroups);
      }
      if (!todo.currentGroupId?.startsWith('$')) {
        this.currentGroupId = todo.currentGroupId;
      }

      // reset properties to enable option2Workflow
      this.enableunion = false;
      this.currentScenario = todo.scenario;
      this.validatedOptionMode = true;
      this.selectedOptionMode = 2;

      // nextTick allows to lets vuejs to load option2workflow before setup its properties
      this.$nextTick(() => {
        if(todo.from === 'case3') {
          this.$refs.option2Workflow.selectedOption = this.wigos;
        } else {
          this.$refs.option2Workflow.selectedOption = null;
        }
        console.log('ConflictResolution: set currentGroupId', this.currentGroupId)
        this.$refs.option2Workflow.currentGroupId = this.currentGroupId;
        console.log('$refs', this.$refs);
      });
      this.wigos = [];
    },

    f_6_01 (todo) {
      console.log("f_6_01")
      this.selectedOptionMode = 4;
      
      //this.shortcutToOption4 = true;
      this.validatedOptionMode = true;
      this.enableunion = false;
      if (todo?.elementsList) {
        this.elementsList = Object.assign({}, todo.elementsList)
      }
      if (todo?.workingPreferences) {
        this.workingPreferencesWf4 = Object.assign({}, todo.workingPreferences);
        this.piPref = Object.assign({}, todo.workingPreferences.pref1);
        this.pjPref = Object.assign({}, todo.workingPreferences.pref2);
      }
      else {
        // reset
        this.workingPreferencesWf4 = Object.assign({}, this.workingPreferencesWf4, { pref1: null, pref2: null });
      }
      this.forceAddForCase6 = false;
      if (todo?.forceAdd) {
        this.forceAddForCase6 = todo.forceAdd;
      }
    },

    sameId(o1, o2) {
      return  o1.id === o2.id;
    },

    loadPreferences (shouldResetCurrentPreference = true, scenarioIdToSelect = undefined) {
      console.log('loadPreferences')
      this.loadingScenarioPreferences = true;
      return scenarioService.getAllPreferences(this.$route.params.id)
        .then(res => {
          this.processPreferences(res.data, shouldResetCurrentPreference, scenarioIdToSelect);
        }).catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] });
        }).finally(() => {
          this.loadingScenarioPreferences = false;
        });
    },

    processPreferences(preferences, shouldResetCurrentPreference = true, scenarioIdToSelect = undefined) {
      this.preferenceList = preferences;

      // For each Si where level(Si) = 1
      this.scenarioList = _.uniqWith(this.preferenceList.map(preference => preference.scenario), sameId);

      if (this.availableScenarii.length && shouldResetCurrentPreference) {
        this.currentScenario = this.availableScenarii[0];
        this.currentPreference = this.preferenceList.find(pref => pref.scenario.id === this.currentScenario.id);
      }
      if(scenarioIdToSelect) {
        console.log('scenarioIdToSelect')
        this.currentScenario = this.scenarioList.find(sce => sce.id === scenarioIdToSelect);
        this.currentPreference = this.preferenceList.find(pref => pref.scenario.id === scenarioIdToSelect);
      }
    },

    unselectOptionMode() {
      this.selectedOptionMode = 0;
      this.validatedOptionMode = false;
    },

    unselectCurrentWorkingPreferences() {
      this.workingPreferencesWf4 = {
        pref1: null,
        pref2: null,
      };
    },

    reinit () {
      this.unselectOptionMode();
      this.originalScenario = undefined;
      this.validatedOptionMode = false;
      this.preferedOption = undefined;
      this.possibleOptions = false;
      this.disallowDrag = false;
      this.currentScenario = {};
      this.currentPreference = {};
      this.currentGroupId = undefined;
      this.unselectCurrentWorkingPreferences();
      this.availableGroups = [];
    },

    goToMinimalScenariosForBeliefs() {
      this.$router.push({name: 'addScenarii', params: { beliefId: this.$route.params.beliefId } });
    },

    backToScenariiList () {
      this.$router.push({name: 'scenariiList', params: { id: this.$route.params.id } });
    },

    goToResolveConflictInCombinationsOfMinimumScenarios () {
      this.reinit();
      this.selectedOptionMode = 4;
      this.validatedOptionMode = true;
      this.navigationPreviousFunction = this.goToResolveConflictWithMinimalScenarios;
      this.navigationPreviousLabel = 'project.resolveConflictsWithinMinimumScenarios';
      this.navigationNextFunction = undefined;
    },

    goToResolveConflictWithMinimalScenarios() {
      this.reinit();
      this.selectedOptionMode = 0;
      this.validatedOptionMode = false;
      this.processPreferences(this.preferenceList, true);

      this.navigationPreviousFunction = this.backToScenariiList;
      this.navigationPreviousLabel = 'project.knowledgeRepresentation';
      this.navigationNextFunction = this.goToResolveConflictInCombinationsOfMinimumScenarios;
      this.navigationNextLabel = 'project.resolveConflictsInCombinationsOfMinimumScenarios';
    },
    f_4_2_08 (todo) {
      this.enableunion = true;
      this.mergedscenario = todo.mergedscenario;
      this.piPref = todo.piPref;
      this.pjPref = todo.pjPref;
      console.log('f_4_2_08 is enabled',this.mergedscenario)
    },

    updateScenario (scenario) {
      console.log('rta', scenario)
      this.preferenceList
      .filter(pref => pref.scenario.id === scenario.id)
      .forEach(pref => pref.scenario = scenario)
    },

    piPrefAndPjPrefSelected (prefs) {
      this.piPref = Object.assign({}, prefs.piPref)
      this.pjPref = Object.assign({}, prefs.pjPref)
    },

    resolveCase6({projectId, piPref, pjPref}) {
      scenarioService.combinePreferencesResolved(projectId, piPref, pjPref)
      .then(() => this.nextTodo())
      .catch(error => {
        this.$emit('raison-event', { type: 'error', message: [error] });
      })
    },
    
  },

  created () {
    this.projectId = this.$route.params.id;
    this.loadingScenarioPreferences = true;
    Promise.all([
      this.beliefMode ? believeService.getBelieves(this.projectId) : optionService.getOptions(this.projectId),
      scenarioService.getAllPreferences(this.$route.params.id)
    ])
    .then(responses => { 
      this.optionList = responses[0].data;
      this.processPreferences(responses[1].data);
      
    }).catch(err => {
      this.$emit('raison-event', { type: 'error', messages: [err] });
    }).finally(() => {
      this.loadingScenarioPreferences = false;
    });
    this.enableunion = false;
  },

};
</script>
